import { MAX_THUMB_BYTES, THUMB_EDGE } from "@vault/shared/media";

const QUALITIES = [0.82, 0.6, 0.4];

export type ThumbSize = { width: number; height: number };

export const fitEdge = (width: number, height: number, edge = THUMB_EDGE): ThumbSize => {
  const longest = Math.max(width, height);
  const scale = longest > edge ? edge / longest : 1;
  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  };
};

export const encodeThumb = async (
  encode: (quality: number) => Promise<Blob | null>,
): Promise<Blob | null> => {
  for (const quality of QUALITIES) {
    const blob = await encode(quality);
    if (!blob) return null;
    if (blob.size <= MAX_THUMB_BYTES) return blob;
  }
  return null;
};
